import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStores(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/store/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchStore(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/store/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addStore(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/store', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteStore(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/store', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
    

  },
}
